module.exports = __webpack_public_path__ + "images/dingtalk/bose-daaa97703fd979a57ece9919c428fbcc.png";